import { useQuery } from '@tanstack/react-query';

import {
  partnersOffersApi,
  partnersOffersApiKeys,
} from '@/api/routes/partners/partners.offers.api';

/** One offer; idle until there is an id (the create form has none). */
export const usePartnersReadOffer = (id?: string) => {
  return useQuery({
    queryKey: partnersOffersApiKeys.detail(id ?? ''),
    queryFn: () => partnersOffersApi.read(id as string).then((res) => res.data.offer),
    enabled: Boolean(id),
  });
};
